import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { postAPI_Update_Property } from '../../../../../../../constants/APIs';
import { PropertyForm } from './PropertyForm';
import  Validation from '../../../../../../../components/Validation';

export default function UpdatePropertyForm({ id, groupId }) {
  const [isUpdating, setIsUpdating] = useState(false);
  const [visible, setVisible] = useState(false);
  const [open,setOpen] = useState(false);
  const [msg,setMsg] =useState([]);
  const handleSubmit = (data) => {
    const formmatedData = { ...data, updater: 'admin' };    
    AxiosAPI({
      method: 'put',
      url: `${postAPI_Update_Property}/${id}`,
      data: formmatedData,
    }).then(
      (res) =>{
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsg(res.data.Messages);
            setOpen(true);
        }
        else {
          setVisible(false);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
        }
      }
    );
  };

  return (
    <div>
      <Button
        color="primary"
        size="sm"
        onClick={() => setIsUpdating(!isUpdating)}
      >
        Edit
      </Button>
      {isUpdating && (
        <PropertyForm
          formLabel="Update Property"
          visible={isUpdating}
          toggle={() => {
            setIsUpdating(!isUpdating);
          }}
          id={id}
          submit={handleSubmit}
          groupId={groupId}
        />
      )}
      <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation>
    </div>
  );
}
